import { __assign } from "tslib";
import * as React from 'react';
import { forwardRef, memo } from 'react';
var RcContact = memo(forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    React.createElement("path", { fill: "#f80", d: "M28 4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-7.586a.997.997 0 0 0-.707.293l-3.141 3.141a.8.8 0 0 1-1.131 0l-3.141-3.141a1 1 0 0 0-.707-.293H4.001a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h24z" }))); }));
RcContact.displayName = 'RcContact';
RcContact['iconName'] = 'rc_contact';
export default RcContact;
